import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import Api from "./utils/apiCall";
import { API_URLS } from "./apis/urls";
import { IDocUploadType } from "../../../feature-module/pages/masters/docUploadTypes";

interface IDocUploadTypesState {
  data: IDocUploadType[];
  loading: boolean;
  error: string | null;
  total: number;
  page: number;
  limit: number;
}

const initialState: IDocUploadTypesState = {
  data: [],
  loading: false,
  error: null,
  total: 0,
  page: 1,
  limit: 10,
};

export const getAllDocUploadTypes = createAsyncThunk(
  'get/allDocUploadTypes',
  async (payload: any, thunkAPI) => {
    try {
      const response = await Api.post(
        API_URLS.MASTERS.FIND_ALL_DOC_UPLOAD_TYPES,
        payload
      );
      return response.data;
    } catch (error: any) {
      return thunkAPI.rejectWithValue(Api.getErrorMessage(error));
    }
  }
);

const docUploadTypesSlice = createSlice({
  name: "docUploadTypes",
  initialState,
  reducers: {
    resetDocUploadTypesState: (state) => {
      state.data = [];
      state.loading = false;
      state.error = null;
      state.total = 0;
      state.page = 1;
      state.limit = 10;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getAllDocUploadTypes.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getAllDocUploadTypes.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload.data.data || [];
        state.total = action.payload.data.total || 0;
        state.page = action.payload.data.page || 1;
        state.limit = action.payload.data.limit || 10;
        state.error = null;
      })
      .addCase(getAllDocUploadTypes.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
        state.data = [];
      });
  },
});

export const { resetDocUploadTypesState } = docUploadTypesSlice.actions;
export default docUploadTypesSlice.reducer;